export default "__VITE_ASSET__ppmTPQGw__"